import gql from 'graphql-tag';

export default gql`
mutation changeAppDelete(
        $uuid: String!
        ) {
    deleteApps(input: {
      uuid: $uuid
    }) {
        uuid
    }
}
`;
